module.exports = __webpack_public_path__ + "img/report.138d4038.png";